// extracted by mini-css-extract-plugin
export default {"rdblock":"JN","container":"KN","rddesc":"LN","title":"MN","copy":"NN","image":"ON","tipview":"PN","rdtip":"QN"};
    if(module.hot) {
      // 1714422956860
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  